import Button from '@material-ui/core/Button';
import Checkbox from '@material-ui/core/Checkbox';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import CheckCircleTwoToneIcon from '@material-ui/icons/CheckCircleTwoTone';
import React from 'react';
import { Alert, Card, CardBody, Row } from 'reactstrap';
import { api } from '../../api';
import { Colxx } from '../../components/common/CustomBootstrap';
import Breadcrumb from '../../containers/navs/Breadcrumb';
import ReCAPTCHA from 'react-google-recaptcha';
import { RECAPTCHA_SITE_KEY } from '../../constants/defaultValues';

const passwordCharacterSets = [
  'abcdefghijklmnopqrstuvwxyz', // Lower case
  'ABCDEFGHIJKLMNOPQRSTUVWXYZ', // Upper case
  '0123456789', // Numbers
  '!@#$%^&*_-=+' // Special characters
];

// Helper function to generate passwords
function generatePassword(length, characterSets) {
  let password = '';

  // Add one of each type of character to the password to start
  for (const set of characterSets) {
    password += set.charAt(Math.floor(Math.random() * set.length));
  }

  // Fill the rest with any character in all the sets
  const fullSet = characterSets.join('');
  for (let characterCount = password.length; characterCount < length; characterCount++) {
    password += fullSet.charAt(Math.floor(Math.random() * fullSet.length));
  }

  // Shuffle the password
  password = password
    .split('')
    .sort(() => {
      return 0.5 - Math.random();
    })
    .join('');

  return password;
}

// TO DO - form validation

const StartTrial = props => {
  const [confirmCheck, setConfirmCheck] = React.useState();
  const [firstName, setFirstName] = React.useState();
  const [lastName, setLastName] = React.useState();
  const [email, setEmail] = React.useState();
  const [company, setCompany] = React.useState();
  const [success, setSuccess] = React.useState(false);
  const [warning, setWarning] = React.useState(null);
  const [captchaSuccess, setCaptchaSuccess] = React.useState(false);

  const sendEmail = () => {
    if (email && firstName && lastName && company && confirmCheck) {
      if (!captchaSuccess) {
        setWarning('Please complete the reCAPTCHA to continue.');
        return;
      }
      api
        .post(`/register`, {
          given_name: firstName,
          family_name: lastName,
          name: company,
          email: email,
          password: generatePassword(12, passwordCharacterSets)
        })
        .then(
          response => {
            console.log(response);
            if (response.data.success === true) {
              setSuccess(true);
              setWarning(null);
            } else {
              setWarning(
                response.data.error ??
                  "An unexpected error occurred while processing your trial request. Your information wasn't saved."
              );
            }
          },
          error => {
            console.log(`Error: ${error}`);
            const errorMessage =
              error?.response?.data?.error ||
              error?.response?.data?.message ||
              error?.message ||
              "An unexpected error occurred while processing your trial request. Your information wasn't saved.";
            setWarning(
              typeof errorMessage === 'string' ? errorMessage : JSON.stringify(errorMessage)
            );
          }
        );
    } else {
      setWarning('Please fill out all required fields.');
    }
  };

  const useStyles = makeStyles(theme => ({
    root: {
      '& .MuiTextField-root': {
        margin: theme.spacing(1),
        width: '25ch'
      },
      textField: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        width: '25ch'
      }
    }
  }));

  const handleFirstName = event => {
    setFirstName(event.target.value);
  };

  const handleLastName = event => {
    setLastName(event.target.value);
  };

  const handleCompany = event => {
    setCompany(event.target.value);
  };

  const handleEmail = event => {
    setEmail(event.target.value);
  };

  const handleConfirmBox = () => {
    setConfirmCheck(!confirmCheck);
  };

  function captchaOnChange(value) {
    // Null value indicates that the captcha expired - only let the user proceed on success
    if (value) {
      setCaptchaSuccess(true);
    } else {
      setCaptchaSuccess(false);
    }
  }

  function captchaOnError(value) {
    setWarning('Unable to verify the CAPTCHA. Please try again.');
    setCaptchaSuccess(false);
  }

  const classes = useStyles();

  return (
    <div>
      <Row>
        <Colxx xxs='12'>
          <Breadcrumb match={props.match} />
        </Colxx>
      </Row>
      <div>
        <section style={{ paddingTop: 60 }}>
          <div style={{ paddingLeft: 60, paddingRight: 60, marginBottom: 60 }}>
            <Row style={{ display: 'flex', justifyContent: 'center' }}>
              <Colxx lg='6'>
                {!success ? (
                  <Card>
                    <CardBody>
                      <h1 style={{ textAlign: 'center', display: 'block', fontWeight: 'bold' }}>
                        Start Your 14-Day Free Trial
                      </h1>
                      <h3 className='mt-3 text-center'>
                        Try Last Record free for 14 days—no credit card required. Your trial
                        includes all free modules, plus <b>Performance Reviews</b>,{' '}
                        <b>TaskBooks / SkillSheets</b>, and <b>detailed reporting</b>.
                      </h3>
                      <h3 className='mt-3 text-center'>
                        At the end of the trial, you can continue using Last Record for{' '}
                        <b>$36 USD per user per year.</b>
                      </h3>
                      <hr />
                      <form className={classes.root} noValidate autoComplete='off'>
                        <div>
                          <TextField
                            required
                            id='firstName'
                            label='First Name'
                            onChange={handleFirstName}
                          />
                          <TextField
                            required
                            id='lastName'
                            label='Last Name'
                            onChange={handleLastName}
                          />{' '}
                          <br />
                          <TextField required id='email' label='Email' onChange={handleEmail} />
                          <TextField
                            required
                            id='company'
                            label='Organization Name'
                            onChange={handleCompany}
                          />{' '}
                          <br />
                        </div>
                        <div style={{ marginLeft: 8 }}>
                          <FormControl>
                            <FormControlLabel
                              control={
                                <Checkbox
                                  onChange={handleConfirmBox}
                                  name='confirmCheck'
                                  color='primary'
                                />
                              }
                              label={
                                <span>
                                  * I agree to the{' '}
                                  <a
                                    href='https://www.lastrecord.com/terms'
                                    target='_blank'
                                    style={{ textDecoration: 'underline' }}
                                  >
                                    terms and conditions
                                  </a>
                                  .
                                </span>
                              }
                            />
                          </FormControl>
                          <ReCAPTCHA
                            sitekey={RECAPTCHA_SITE_KEY}
                            onChange={captchaOnChange}
                            onError={captchaOnError}
                          />
                        </div>
                        <div>
                          <Button
                            variant='contained'
                            style={{ marginLeft: 8, marginTop: 20 }}
                            onClick={() => sendEmail()}
                          >
                            Submit
                          </Button>
                        </div>
                        {warning !== null && (
                          <Alert className='mt-4' color='danger'>
                            <p className='text-default mb-0'>{warning}</p>
                          </Alert>
                        )}
                      </form>
                    </CardBody>
                  </Card>
                ) : (
                  <Card>
                    <CardBody>
                      <div style={{ textAlign: 'center', display: 'block' }}>
                        <CheckCircleTwoToneIcon
                          style={{ position: 'relative', color: '#119e11', fontSize: '5rem' }}
                        />{' '}
                      </div>
                      <h1 style={{ textAlign: 'center', display: 'block', fontWeight: 'bold' }}>
                        You're all set — your trial is approved!
                      </h1>
                      <h3 className='mt-3 text-center'>
                        An email has been sent to you with your username and provisional password.
                      </h3>
                      <h3 className='mt-3 text-center'>
                        Use those details to log in and start exploring Last Record.
                      </h3>
                    </CardBody>
                  </Card>
                )}
              </Colxx>
            </Row>
          </div>
        </section>
      </div>
    </div>
  );
};

export default StartTrial;
